// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"612":"aefcb5ab","1098":"aefcb5ab","1392":"eb268864","4421":"e9b1362f","5388":"82421dcc","8545":"aefcb5ab"}[chunkId] + ".chunk.css";
};